import { postRequest } from '../helpers/utilities';

const venuesGridFunctions = () => {
	const loadMoreBtns = document.querySelectorAll('.js-venues-load-more');

	if (loadMoreBtns) {
		loadMoreBtns.forEach(btn => {
			btn.addEventListener('click', async () => {
				const itemsContainer = btn.closest('.venues-grid__category').querySelector('.js-venues-items');
				const categoryId = itemsContainer.dataset.venuesCategoryId;

				loadMoreVenues(categoryId, itemsContainer, btn);
			});
		});
	}
};

const loadMoreVenues = async (categoryId = null, itemsContainer, loadMoreBtn) => {
	itemsContainer.classList.add('loading');

	// Add loading state to button
	loadMoreBtn.classList.add('opacity-50', 'pointer-events-none');
	loadMoreBtn.querySelector('span').textContent = 'Loading...';

	const offset = itemsContainer.querySelectorAll('.js-venues-item').length;
	let ppp = itemsContainer.dataset.ppp ? parseInt(itemsContainer.dataset.ppp) : 6;

	// Fetch the venues
	try {
		// Get the fetch data
		const getFetchData = () => {
			const formData = new FormData();

			formData.append('action', 'get_venues_items_ajax');
			formData.append('ppp', ppp);
			formData.append('offset', offset);

			if (categoryId) {
				formData.append('categoryId', categoryId);
			}

			const ajaxData = new URLSearchParams(formData);

			return ajaxData;
		};

		const fetchData = getFetchData();

		// Fetch the venues
		const data = await postRequest(fetchData);

		// Check if the venues are fetched successfully
		if (data.success && data.venues) {
			setTimeout(() => {
				// Add new venues to the container
				itemsContainer.innerHTML += data.venues;

				// Reset button
				if (loadMoreBtn) {
					loadMoreBtn.classList.remove('opacity-50', 'pointer-events-none');
					loadMoreBtn.querySelector('span').textContent = 'View More';

					// Hide button if all items are loaded
					if (
						itemsContainer.querySelectorAll('.js-venues-item').length >=
						parseInt(itemsContainer.dataset.venuesCategoryCount)
					) {
						loadMoreBtn.classList.add('!hidden');
					} else {
						loadMoreBtn.classList.remove('!hidden');
					}
				}

				// Remove loading state
				itemsContainer.classList.remove('loading');
			}, 400);
		} else {
			// Show error message
			alert('An error occurred while fetching the venues. Please try again later.');
		}
	} catch (error) {
		// Show error message
		alert('An error occurred while fetching the venues. Please try again later.');
		console.error(error);
	}
};

venuesGridFunctions();
